<template>
    <!-- Sections (Assets & Services) -->
    <CreateAsset />
    <YourServices />
</template>
<script>
    import CreateAsset from '@/layouts/client/create_asset/CreateAsset.vue';
    import YourServices from '@/layouts/client/services/YourServices.vue';

    export default {
    name: 'ToolBox',
    components: {
        CreateAsset,
        YourServices
    },
};
</script>